/**
 * Pure locale matching and resolution (KORA-122). Generic over the supported list so every product
 * passes the languages it actually ships. No imports: keeps the module graph acyclic.
 */
/** Exact match after trim + lower-case. Used for validation (Kora) and stored-value reads. */
export function findSupportedLocale(supported, value) {
    if (typeof value !== 'string')
        return null;
    const normalised = value.trim().toLowerCase();
    return supported.find(candidate => candidate === normalised) ?? null;
}
/** Exact match, else primary-subtag match ('de-AT' → 'de', 'EN-us' → 'en'). Non-strings → null. */
export function matchLocaleTag(supported, tag) {
    if (typeof tag !== 'string')
        return null;
    const exact = findSupportedLocale(supported, tag);
    if (exact !== null)
        return exact;
    const primary = tag.trim().split(/[-_]/)[0];
    return findSupportedLocale(supported, primary);
}
/** Precedence: override → account → first matching browser tag → fallback. */
export function resolveLocalePreference(supported, fallback, sources) {
    const override = findSupportedLocale(supported, sources.productOverride);
    if (override !== null)
        return override;
    const account = findSupportedLocale(supported, sources.accountLocale);
    if (account !== null)
        return account;
    for (const tag of sources.browserLanguages ?? []) {
        const matched = matchLocaleTag(supported, tag);
        if (matched !== null)
            return matched;
    }
    return fallback;
}
